import { createFileRoute } from '@tanstack/react-router'
import { PerfilPage } from '@/pages/perfil/PerfilPage'

export const Route = createFileRoute('/_auth/perfil')({
  component: PerfilPage,
})
